import { RefObject, useEffect, useRef } from 'react';

export function useModalControl(
  isOpen: boolean,
  onClose: () => void,
): {
  modalReference: RefObject<HTMLDivElement>
} {
  const modalReference = useRef<HTMLDivElement>(null);

  function isSnackbarComponent(target: HTMLElement): boolean {
    let element: HTMLElement | null = target;

    while (element !== null) {
      if (element.classList.contains('Toastify')) {
        return true;
      }
      element = element.parentElement;
    }

    return false;
  }

  function isSelectComponent(target: HTMLElement): boolean {
    return !!target.closest('.select-search__select');
  }

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      const target = event.target as HTMLElement;

      if (modalReference.current
        && !modalReference.current.contains(target)
        && !isSnackbarComponent(target)
        && !isSelectComponent(target)
      ) {
        onClose();
      }
    }

    function handleKeyClose(event: KeyboardEvent) {
      if (isOpen && event.key === 'Escape') {
        onClose();
      }
    }

    if (isOpen) {
      document.body.style.overflow = 'hidden';
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleKeyClose);
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKeyClose);
    };
  }, [isOpen, onClose]);

  return {
    modalReference,
  };
}
